const CompetitionStacking = {
    COMPETITION_STACKING_SET_IS_USED: 'COMPETITION_STACKING_SET_IS_USED',
    COMPETITION_STACKING_ADD_ITEM: 'COMPETITION_STACKING_ADD_ITEM',
    COMPETITION_STACKING_SET_COMPETITION: 'COMPETITION_STACKING_SET_COMPETITION',
    COMPETITION_STACKING_SET_EXPOSURE: 'COMPETITION_STACKING_SET_EXPOSURE',
    COMPETITION_STACKING_REMOVE_ITEM: 'COMPETITION_STACKING_REMOVE_ITEM',

    COMPETITION_STACKING_TYPE_FIGHT: 'fight',
    COMPETITION_STACKING_TYPE_MATCH: 'match',
};

export default CompetitionStacking;
